import { useEffect, useRef } from "react";

const InstagramEmbed = ({ url }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Cleanup old content
    if (containerRef.current) {
      containerRef.current.innerHTML = "";

      const blockquote = document.createElement("blockquote");
      blockquote.className = "instagram-media";
      blockquote.setAttribute("data-instgrm-permalink", url);
      blockquote.setAttribute("data-instgrm-version", "14");
      blockquote.style.width = "100%";
      blockquote.style.margin = "0 auto";

      containerRef.current.appendChild(blockquote);
    }

    const scriptAlreadyLoaded = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (!scriptAlreadyLoaded) {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = () => {
        if (window.instgrm) {
          window.instgrm.Embeds.process();
        }
      };
      document.body.appendChild(script);
    } else {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    }
  }, [url]);

  return (
    <div
      ref={containerRef}
      style={{
        height: "310px", // match YouTube height
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  );
};

export default InstagramEmbed;
